import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { FILTERING_RULE_FRAGMENT_FOR_UPDATE } from './fragment'
import { Data, Variables } from './types'

export const UPDATE_FILTERING_RULE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${FILTERING_RULE_FRAGMENT_FOR_UPDATE}
  ${ERROR_FRAGMENT}

  mutation updateFilteringRule($input: UpdateFilteringRuleInput!) {
    updateFilteringRule(input: $input) {
      filteringRule {
        ...FilteringRuleFragmentForUpdate
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
